import { ReduxAction } from 'types/redux';
import { CONFIRM_CODE } from "../../constants/confirm-code.constants";

const initialState = {
  loading: false,
  data: false,
  error: '',
  token: '',
};

export function confirmCode(state = initialState, action: ReduxAction) {
  switch (action.type) {
    case CONFIRM_CODE.CONFIRM_CODE_REQUEST:
      return {
        ...state,
        loading: true,
        data: false,
        error: '',
      };
    case CONFIRM_CODE.CONFIRM_CODE_SUCCESS:
      return {
        ...state,
        data: true,
        loading: false,
        error: '',
        token: action.token
      };
    case CONFIRM_CODE.CONFIRM_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        data: false,
        error: action.error,
      };
    case CONFIRM_CODE.CONFIRM_CODE_CLEAR:
      return {
        ...state,
        loading: false,
        data: false,
        error: '',
      };
    default:
      return state;
  }
}
